import moment from "moment";
import React, { useEffect, useState } from "react";
import Table2 from "../../../../templates/components/Table2";
import ChartNotesService from "../../../../../services/api/chart-notes.service";
import { useGetLocationProviderServices, useGetLocationServiceTypes } from "../../../../../services/cache/CacheService";

const ChartNotesHistoryTable = (props) => {
  const [chartNotesHistory, setChartNotesHistory] = useState(props.initialData || [])
  const [isLoader, setIsLoader] = useState(false);
  const [providersList, setProvidersList] = useState([])
  const [practiceServiceTypeList, setPracticeServiceTypeList] = useState([])
  const stateDoctorList = useGetLocationProviderServices();
  const stateServiceTypeList = useGetLocationServiceTypes()
  const hiddenColumns = ["appointmentDate"]
  const tableColumns = [
    {
      id: "appointmentDate",
      Header: "Date",
      accessor: (cell) => {
        return cell.appointmentDate ? moment(cell.appointmentDate).format("MM/DD/YYYY") : ""
      }
    },
    {
      id: "doctorId",
      Header: "Provider",
      accessor: (row) => {
        let selectedDoctor = providersList?.find((obj) => obj.id === row.doctorId)
        return selectedDoctor ? (selectedDoctor.firstName + ' ' + selectedDoctor.lastName) : ""
      }
    },
    {
      id: "practiceServiceType",
      Header: "Service",
      accessor: (row) => {
        let service = practiceServiceTypeList?.find(obj => obj.practiceServiceTypeId === row.practiceServiceTypeId)
        if (service) return service.practiceServiceType
        return ''
      }
    },
    // {
    //   id: "area",
    //   Header: "Area",
    //   accessor: (cell) => cell.area,
    // },
    // {
    //   id: "productName",
    //   Header: "Product",
    //   accessor: (cell) => cell.productName,
    // },
    // {
    //   id: "quantity",
    //   Header: "Quantity",
    //   accessor: (cell) => cell.quantity?.toLocaleString() ?? "",
    // },
    {
      id: "notes",
      Header: "Notes",
      accessor: (cell) => cell.notes,
    },
  ];

  const getChartNotes = () => {
    setIsLoader(true)
    const reqObj = {
      PatientIds: props?.patientId
    };
    ChartNotesService.getChartNotes(reqObj)
      .then(res => {
        if (res?.data && Array.isArray(res.data)) {
          let responsive = res.data.sort(function (a, b) {
            return new Date(a.appointmentDate) - new Date(b.appointmentDate);
          });
          // History is everything for patient as no appt id is passed
          setChartNotesHistory(responsive)
        }
      })
      .catch((err) => {
      }).finally(() => {
        setIsLoader(false)
      });
  }
  useEffect(async () => {
    if (stateDoctorList) {
      setProvidersList(stateDoctorList)
    }
  }, [stateDoctorList]);
  useEffect(async () => {
    if (stateServiceTypeList) {
      setPracticeServiceTypeList(stateServiceTypeList)
    }
  }, [stateServiceTypeList]);

  useEffect(() => {
    //called from patient card
    if (props.patientId) {
      getChartNotes()
    }
  }, [])

  return (
    <>
      <Table2
        hiddenColumns={hiddenColumns}
        data={chartNotesHistory}
        columns={tableColumns}
        loading={props.isLoader || isLoader}
      />
    </>
  );
};

export default ChartNotesHistoryTable;
